import React, { useState } from "react";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

const Navbar = ({ className }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  return (
    <div
      className={`bg-gray-50/10 ${className || ""} ${
        openDrawer ? "" : "backdrop-blur-md"
      } text-white fixed w-full top-0 z-[9999]`}
    >
      <div className="hidden lg:block">
        <DesktopNav />
      </div>
      <div className="block lg:hidden">
        <MobileNav openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
      </div>
    </div>
  );
};

export default Navbar;
